import { AxiosService } from './axios.service'
import { StorageService } from './storage.service'

/**
 * Defines the API methods for payment methods/installments
 */
export class PaymentService {
	/**
	 * Get the available payment methods, fees and installment options for the current cart
	 * @return {Promise<any>} { methods, installments, conversionRateToken, expiresAtUtc, fxRates }
	 */
	static getMethods() {
		const cart = StorageService.cart.get()

		return AxiosService.getMuviHub('payments/methods', {
			params: { cartId: cart && cart.id }
		}).then(({ data }) => data.data)
	}
}
